import axios from '@/axios-auth'
import Vue from 'vue'
import utils from '@/utils'

// Due to avoid name conflicts with the other store modules
// we make us of *List instead of simply using plural
const state = {
  adminContractPartnerList: [],
  adminContractPartnerTemplateList: [],
  adminContractPartner: {},
  adminAddresses: null,
  adminContactPersons: null,
  adminContracts: [],
  adminCertificateOfDeath: null,
  adminCertificateOfInheritance: null,
  adminPowerOfAttorney: null,
  adminUserInvitationList: null,
  userById: {},
  userList: []
}

const getters = {
  adminAddresses: state => state.adminAddresses,
  adminContactPersons: state => state.adminContactPersons,
  adminContracts: state => state.adminContracts,
  adminCertificateOfDeath: state => state.adminCertificateOfDeath,
  adminCertificateOfInheritance: state => state.adminCertificateOfInheritance,
  adminPowerOfAttorney: state => state.adminPowerOfAttorney,
  adminUserInvitationList: state => state.adminUserInvitationList,
  adminContractPartner: state => state.adminContractPartner,
  adminContractPartnerList: state => state.adminContractPartnerList,
  adminContractPartnerTemplateList: state => state.adminContractPartnerTemplateList,
  userById: state => state.userById,
  adminUserList: state => state.userList
}

const actions = {
  deleteAdminContractPartnerTemplate ({commit, dispatch, getters}, contractPartner) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.delete(`/management/contractPartnerTemplates/${contractPartner.id}`, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        commit('removeAdminContractPartnerTemplate', contractPartner.id)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((error) => reject(error))
    })
  },
  fetchAdminContractPartnerById ({commit, dispatch, getters}, id) {
    return new Promise((resolve, reject) => {
      const adminContractPartner = state.adminContractPartnerList.find(adminContractPartner => adminContractPartner.id === id)
      if (adminContractPartner) {
        commit('setAdminContractPartner', adminContractPartner)
        resolve()
      } else {
        const currentUser = getters.currentUser
        const idToken = currentUser.idToken
        const authValue = 'Bearer '.concat(idToken)
        axios.get(`/management/contractPartners/${id}`, {
          headers: {
            Authorization: authValue
          }
        }).then((response) => {
          commit('setAdminContractPartner', response.data)
          dispatch('setLogoutTimer')
          resolve()
        }).catch((error) => reject(error))
      }
    })
  },
  fetchAdminContractPartnerList ({getters, commit, dispatch}) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get('/management/contractPartners', {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setAdminContractPartnerList', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((error) => reject(error))
    })
  },
  fetchAdminContractPartnerTemplateById ({commit, dispatch, getters}, id) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/management/contractPartnerTemplates/${id}`, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setAdminContractPartner', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((error) => reject(error))
    })
  },
  fetchAdminContractPartnerTemplateList ({getters, commit, dispatch}) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get('/management/contractPartnerTemplates', {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setAdminContractPartnerTemplateList', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((error) => reject(error))
    })
  },
  fetchUserList ({getters, commit, dispatch}, onlyPhCp) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/management/users`, {
        headers: {
          Authorization: authValue
        },
        params: {
          onlyPhCp: onlyPhCp
        }
      }).then((response) => {
        commit('setUserList', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  fetchAdminAddresses ({getters, commit, dispatch}, userId) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/management/users/${userId}/addresses`, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setAdminAddresses', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  fetchAdminContracts ({getters, commit, dispatch}, userId) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/management/users/${userId}/contracts`, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setAdminContracts', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  fetchUserById ({getters, commit, dispatch}, userId) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/management/users/${userId}`, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setUserById', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  fetchAdminContactPersons ({getters, commit, dispatch}, userId) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/management/users/${userId}/contactPersons`, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setAdminContactPersons', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => {
        commit('setAdminContactPersons', null)
        reject(err)
      })
    })
  },
  setHeirStatus ({getters, commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.put(`/management/users/${data.phId}/contactPersons/${data.contactPersonId}/certificateOfInheritanceSettings`, {
        isCertificateOfInheritanceApproved: data.isCertificateOfInheritanceApproved,
        isEntitledInCertificateOfInheritance: data.isEntitledInCertificateOfInheritance
      }, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  deleteAdminCertificateOfDeath ({getters, commit, dispatch}, policyHolderId) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.delete(`/management/users/${policyHolderId}/certificateOfDeath`, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        commit('setAdminCertificateOfDeath', null)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  deleteAdminCertificateOfInheritance ({getters, commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.delete(`/management/users/${data.policyHolderId}/contactPersons/${data.cpId}/certificateOfInheritance`, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        commit('setAdminCertificateOfInheritance', null)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  deleteAdminPowerOfAttorney ({getters, commit, dispatch}, policyHolderId) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.delete(`/management/users/${policyHolderId}/powerOfAttorny`, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        commit('setAdminPowerOfAttorney', null)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  fetchAdminCertificateOfDeath ({getters, commit, dispatch}, userId) {
    return new Promise((resolve) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/management/users/${userId}/certificateOfDeath`, {
        responseType: 'arraybuffer',
        headers: {
          Authorization: authValue,
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        const poaMeta = utils.contentDispositionToMeta(response)
        poaMeta.file = response.data
        commit('setAdminCertificateOfDeath', poaMeta)
        dispatch('setLogoutTimer')
        resolve()
      }).catch(() => {
        commit('setAdminCertificateOfDeath', null)
      })
    })
  },
  fetchAdminCertificateOfInheritance ({getters, commit, dispatch}, data) {
    const currentUser = getters.currentUser
    const idToken = currentUser.idToken
    const authValue = 'Bearer '.concat(idToken)
    return new Promise((resolve, reject) => {
      axios.get(`/management/users/${data.policyHolderId}/contactPersons/${data.cpId}/certificateOfInheritance`, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        if (response.data.certificateOfInheritance) {
          const certificateOfInheritanceMeta = {}
          certificateOfInheritanceMeta.file = response.data.certificateOfInheritance
          commit('setAdminCertificateOfInheritance', certificateOfInheritanceMeta)
        } else {
          commit('setAdminCertificateOfInheritance', null)
        }
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => {
        commit('setAdminCertificateOfInheritance', null)
        reject(err)
      })
    })
  },
  fetchAdminPowerOfAttorney ({getters, commit, dispatch}, userId) {
    return new Promise((resolve) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/management/users/${userId}/powerOfAttorny`, {
        responseType: 'arraybuffer',
        headers: {
          Authorization: authValue,
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        const poaMeta = utils.contentDispositionToMeta(response)
        poaMeta.file = response.data
        commit('setAdminPowerOfAttorney', poaMeta)
        dispatch('setLogoutTimer')
        resolve()
      }).catch(() => {
        commit('setAdminPowerOfAttorney', null)
      })
    })
  },
  uploadAdminCertificateOfDeath ({getters, commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      const formData = new FormData()
      formData.append('file', data.certificateOfDeath)
      axios.post(`/management/users/${data.policyHolderId}/certificateOfDeath`, formData, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        const certificateOfDeathMeta = {}
        certificateOfDeathMeta.uploaderId = currentUser.id
        certificateOfDeathMeta.filename = data.certificateOfDeath.name
        certificateOfDeathMeta.mimeType = data.certificateOfDeath.type
        certificateOfDeathMeta.file = data.certificateOfDeath
        commit('setAdminCertificateOfDeath', certificateOfDeathMeta)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  uploadAdminCertificateOfInheritance ({getters, commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.post(`/management/users/${data.policyHolderId}/contactPersons/${data.cpId}/certificateOfInheritance`, data.documents, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        const certificateOfInheritanceMeta = {}
        certificateOfInheritanceMeta.file = data.documents.certificateOfInheritance
        certificateOfInheritanceMeta.filename = data.file.name
        commit('setAdminCertificateOfInheritance', certificateOfInheritanceMeta)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  storeAdminContractPartnerTemplate ({commit, dispatch, getters}, contractPartnerTemplate) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      if ('isDeletable' in contractPartnerTemplate) {
        axios.put(`/management/contractPartnerTemplates/${contractPartnerTemplate.id}`, contractPartnerTemplate, {
          headers: {
            Authorization: authValue
          }
        }).then((response) => {
          commit('addAdminContractPartnerTemplate', response.data)
          dispatch('setLogoutTimer')
          resolve()
        }).catch((error) => reject(error))
      } else {
        axios.post('/management/contractPartnerTemplates', contractPartnerTemplate, {
          headers: {
            Authorization: authValue
          }
        }).then((response) => {
          commit('addAdminContractPartnerTemplate', response.data)
          dispatch('setLogoutTimer')
          resolve()
        }).catch((error) => reject(error))
      }
    })
  },
  uploadAdminPowerOfAttorney ({getters, commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      const formData = new FormData()
      formData.append('file', data.powerOfAttorney)
      axios.post(`/management/users/${data.policyHolderId}/powerOfAttorny`,
        formData,
        {
          headers: {
            Authorization: authValue
          }
        }
      ).then(() => {
        const powerOfAttorneyMeta = {}
        powerOfAttorneyMeta.filename = data.powerOfAttorney.name
        powerOfAttorneyMeta.mimeType = data.powerOfAttorney.type
        powerOfAttorneyMeta.file = data.powerOfAttorney
        commit('setAdminPowerOfAttorney', powerOfAttorneyMeta)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  fetchAdminUserInvitationList ({getters, commit, dispatch}, userId) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/management/users/${userId}/invitations`, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        commit('setAdmiUserInvitationList', response.data)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  markAsDead ({getters, commit, dispatch}, data) {
    const currentUser = getters.currentUser
    const idToken = currentUser.idToken
    const authValue = 'Bearer '.concat(idToken)
    return new Promise((resolve, reject) => {
      axios.put(`/management/users/${data.id}/markAsDead`, {dateOfDeath: data.dateOfDeath}, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        dispatch('setLogoutTimer')
        resolve(data.dateOfDeath)
      }).catch((err) => reject(err))
    })
  },
  authorize ({getters, commit, dispatch}, data) {
    const currentUser = getters.currentUser
    const idToken = currentUser.idToken
    const authValue = 'Bearer '.concat(idToken)
    return new Promise((resolve, reject) => {
      axios.put(`/management/users/${data.id}/authorize`, {isAuthorized: data.isAuthorized}, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  }
}

const mutations = {
  addAdminContractPartnerTemplate (state, adminContractPartnerTemplate) {
    state.adminContractPartnerTemplateList.push(adminContractPartnerTemplate)
  },
  setAdminContractPartner (state, adminContractPartner) {
    state.adminContractPartner = adminContractPartner
  },
  setAdminContractPartnerList (state, adminContractPartnerList) {
    state.adminContractPartnerList = adminContractPartnerList
  },
  setAdminContractPartnerTemplateList (state, adminContractPartnerTemplateList) {
    state.adminContractPartnerTemplateList = adminContractPartnerTemplateList
  },
  setAdminAddresses (state, adminAddresses) {
    state.adminAddresses = adminAddresses
  },
  setAdminContactPersons (state, adminContactPersons) {
    state.adminContactPersons = adminContactPersons
  },
  setAdminContracts (state, adminContracts) {
    state.adminContracts = adminContracts
  },
  setAdminCertificateOfDeath (state, adminCertificateOfDeath) {
    state.adminCertificateOfDeath = adminCertificateOfDeath
  },
  setAdminCertificateOfInheritance (state, adminCertificateOfInheritance) {
    state.adminCertificateOfInheritance = adminCertificateOfInheritance
  },
  setAdminPowerOfAttorney (state, adminPowerOfAttorney) {
    state.adminPowerOfAttorney = adminPowerOfAttorney
  },
  setAdmiUserInvitationList (state, adminUserInvitationList) {
    state.adminUserInvitationList = adminUserInvitationList
  },
  setUserById (state, userById) {
    state.userById = userById
  },
  setUserList (state, userList) {
    state.userList = userList
  },
  removeAdminContractPartnerTemplate (state, id) {
    const templateIndex = state.adminContractPartnerTemplateList.findIndex(template => template.id === id)
    if (templateIndex !== -1) {
      Vue.delete(state.adminContractPartnerTemplateList, templateIndex)
    }
  },
  updateAdminContractPartnerCity (state, city) {
    Vue.set(state.adminContractPartner, 'city', city)
  },
  updateAdminContractPartnerCountry (state, country) {
    Vue.set(state.adminContractPartner, 'country', country)
  },
  updateAdminContractPartnerDomain (state, domain) {
    Vue.set(state.adminContractPartner, 'domain', domain)
  },
  updateAdminContractPartnerEmail (state, email) {
    Vue.set(state.adminContractPartner, 'email', email)
  },
  updateAdminContractPartnerName (state, name) {
    Vue.set(state.adminContractPartner, 'contractPartnerName', name)
  },
  updateAdminContractPartnerStreet (state, street) {
    Vue.set(state.adminContractPartner, 'street', street)
  },
  updateAdminContractPartnerStreetNumber (state, streetNumber) {
    Vue.set(state.adminContractPartner, 'streetNumber', streetNumber)
  },
  updateAdminContractPartnerPostalCode (state, postalCode) {
    Vue.set(state.adminContractPartner, 'postalCode', postalCode)
  },
  updateAdminContractPartnerPostOfficeBox (state, postOfficeBox) {
    Vue.set(state.adminContractPartner, 'postOfficeBox', postOfficeBox)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/admin.js